export enum FontFamilyType {
    POPPINS = 'Poppins, Helvetica, sans-serif',
	ROBOTO = 'Roboto, "Helvetica Neue", sans-serif',
}
